<template>
  <v-container-np id="services">
    <v-container-restricted
      class="text-center d-flex flex-column align-center"
      :class="Spacings.homePageSectionPadding"
    >
      <underlined-heading :text="$t('taHome.services')"></underlined-heading>

      <v-container-np
        v-for="(service, index) in services"
        :class="Spacings.homePageHeadingMargin"
      >
        <SlideOnIntersectContainer
          :direction="index % 2 === 1 ? 'right' : 'left'"
        >
          <v-row
            align="center"
            no-gutters
            :class="{
              'justify-end ': index % 2 === 1,
            }"
            class="w-100 text-center text-sm-left"
          >
            <v-col
              cols="12"
              sm="8"
              md="4"
              lg="3"
              :order-md="index % 2 !== 1 ? '0' : '1'"
            >
              <div
                class="rounded-xl bg-white overflow-hidden"
                style="width: 100%; aspect-ratio: 4/2.5"
              >
                <Image
                  :cover="false"
                  :full-height="true"
                  :full-width="true"
                  :src="service.img"
                ></Image>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="8"
              md="8"
              lg="7"
              :order-lg="index % 2 !== 1 ? '1' : '0'"
              class="px-0 py-3 py-md-0 px-md-10"
            >
              <h2 class="mt-3 text-h6 text-sm-h5 mb-3">{{ service.name }}</h2>
              <p class="text-subtitle-1">
                {{ service.description }}
              </p>
            </v-col>
          </v-row>
        </SlideOnIntersectContainer>
        <v-row v-if="index !== services.length - 1" no-gutters justify="center">
          <v-divider
            opacity="0.5"
            length="250px"
            thickness="10"
            class="rounded-lg mt-5 mt-md-8"
            color="primary"
          ></v-divider>
        </v-row>
      </v-container-np>
    </v-container-restricted>
  </v-container-np>
</template>
<script setup lang="ts">
import { Spacings } from "~/core/constants/vuetify-class-constants/spacings";

const services: { name: string; img: string; description: string }[] = [
  {
    name: "AI Consulting",
    img: "https://img.freepik.com/free-vector/scientists-studying-neural-connections-programmers-writing-codes-machine-brain_74855-14157.jpg?t=st=1717598774~exp=1717602374~hmac=5687e81877d06dc2858fed9e74dc69e7cfe85deed7802adefd0fdbc94a945d05&w=400",
    description:
      "Our AI Consulting services provide expert guidance to help businesses leverage artificial intelligence to optimize operations, improve decision-making, and drive innovation. We work closely with clients to identify AI opportunities, develop strategies, and implement solutions tailored to their unique needs.",
  },
  {
    name: "Machine Learning Solutions",
    img: "https://img.freepik.com/free-vector/ai-powered-content-creation-isometric-concept-with-chatbot-laptop-screen-3d-vector-illustration_1284-82523.jpg?t=st=1717598879~exp=1717602479~hmac=21fda66dff51e9d682026f00c6a94b7c28d8068f1ff60a9c40df8f9cb24cca2d&w=400",
    description:
      "Our Machine Learning Solutions offer cutting-edge algorithms and models to solve complex business problems. We design and deploy scalable machine learning systems that enhance predictive analytics, automate processes, and deliver actionable insights, enabling clients to achieve competitive advantages.",
  },
  {
    name: "Data Analytics",
    img: "https://img.freepik.com/free-vector/data-inform-illustration-concept_114360-864.jpg?t=st=1717598153~exp=1717601753~hmac=66a07883c8cd66674dbc2b5f4bfdb7e6de808f243104150dd051550deabfaed4&w=400",
    description:
      "Our Data Analytics services transform raw data into valuable insights. We utilize advanced analytical techniques to uncover patterns, trends, and correlations, helping businesses make data-driven decisions. From data visualization to predictive modeling, we provide comprehensive analytics solutions to optimize performance and growth.",
  },
  {
    name: "Custom AI Solutions",
    img: "https://img.freepik.com/free-vector/cute-chatbot-greeting-people-isometric-icon-with-computer-various-objects-3d_1284-63055.jpg?t=st=1717598993~exp=1717602593~hmac=9e32ea39748677189cb1aacb4e001956a10082b77092297d5784027d94f8bb99&w=400",
    description:
      "Our Custom AI Solutions are tailored to meet the specific needs of each client. We develop bespoke machine learning models and applications that address unique business challenges. Whether it's for improving customer experience, optimizing operations, or innovating products, our custom solutions deliver measurable results.",
  },
];
</script>
